import React from 'react'
import DCFAnalysisContainer from 'components/wrapper/DCFAnalysisContainer'
import { getRequiredAnalysis, postRequiredAnalysis } from 'api/urls'
import { useHistory } from 'react-router'
import { getQueryParams } from 'utils/Utils'

const dcf_analysis = {
    initial_cash_flow: {
        lable: 'Base FCF (₹ Cr)',
        placeholder: 'Ex: 100',
        col: 6,
    },
    initial_growth_rate: {
        lable: 'Growth yrs 1-5 (%)',
        placeholder: 'Ex: 10',
        col: 6,
    },
    mid_growth_rate: {
        lable: 'Growth yrs 6-10 (%)',
        placeholder: 'Ex: 10',
        col: 6,
    },
    discount_rate: {
        lable: 'Discount rate (%)',
        placeholder: 'Ex: 12',
        col: 6,
    },
    terminal_growth_rate: {
        lable: 'Terminal growth (%)',
        placeholder: 'Ex: 12',
        col: 6,
    },
    outstanding_share: {
        style: { border: 'none', background: 'none', fontWeight: '600', cursor: 'auto',color:'black',textTransform: 'capitalize' },
        lable: 'Shares (Rs Cr.)',
        placeholder: '0',
        readOnly: true,
        col: 6,
    },
    net_debt: {
        style: { border: 'none', background: 'none', fontWeight: '600', cursor: 'auto',color:'black',textTransform: 'capitalize' },
        lable: 'Net Debt (Rs Cr.)',
        placeholder: '0',
        readOnly: true,
        col: 6,
    },
}

const DCFAnalysis = (props) => {
    const history = useHistory()
    const querryParams = getQueryParams(history.location.search)
    return (
        <div  {...props}>
            <DCFAnalysisContainer
                postUrl={postRequiredAnalysis('/dcf_analysis/')}
                url={getRequiredAnalysis('dcf', querryParams.company__symbol)}
                analysis={dcf_analysis}
                dcfKey={true}
            />
        </div>
    )
}

export default (DCFAnalysis);